import Vue from 'vue'
import Auth from '../components/auth';
import Main from '../components/main';
import User from '../components/user';
import Router from 'vue-router'
import beforeEach from './beforeEach'
import { routes as userPortal } from '../app/userportal'
import { routes as teamPortal } from '../app/teamportal'
import { routes as auth } from '../app/auth'
import { routes as mainRoutes } from '../app'

Vue.use(Router)

// https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Operators/Spread_operator
const routes = [
    {
        name: 'auth',
        path: '/auth',
        component: Auth,
        meta: { requiresAuth: false },
        children: [ ...auth],
        redirect: { name: 'auth.login' }
    },
    {
        name: 'teamPortal',
        path: '/teamportal',
        component: User,
        //meta: { requiresAuth: true },
        children: [ ...teamPortal],
        //redirect: { name: 'auth.userportalLogin' }
    },
    {
        path: '/',
        component: Main,
        meta: { requiresAuth: true },
        children: [ ...mainRoutes],
        redirect: { name: 'dashboard.index' }
    },
    {
        name: 'userPortal',
        path: '/userPortal',
        component: User,
        meta: { requiresAuth: true },
        children: [ ...userPortal],
        redirect: { name: 'auth.userportalLogin' }
    },
    {
        name: 'catchall',
        path: '*',
        redirect: { name: 'dashboard.index' }
    },
]

const router = new Router({
    routes,
    linkActiveClass: 'active',
    mode: 'history', // do not use /#/.
});

/**
* Before a route is resolved we check for
* the token if the route is marked as
* requireAuth.
*/
router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js